var connectManager = {
	init: function(){
		//get the height of the lis
		var mx = 0;
		var cI = $(".connectItem");
		cI.each(function(){
			var t = $(this);
			if(t.height() > mx){
				// console.log(t.height());
				mx = t.height();
			}
		});
		cI.height(mx);
	}
};
